/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetRating
 */
export interface AssetRating {
    /**
     * 
     * @type {number}
     * @memberof AssetRating
     */
    id: number;
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof AssetRating
     */
    user: ElementsUserMiniReference;
    /**
     * 
     * @type {number}
     * @memberof AssetRating
     */
    rating?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetRating
     */
    readonly date: Date;
    /**
     * 
     * @type {number}
     * @memberof AssetRating
     */
    asset: number;
}

export function AssetRatingFromJSON(json: any): AssetRating {
    return AssetRatingFromJSONTyped(json, false);
}

export function AssetRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetRating {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': ElementsUserMiniReferenceFromJSON(json['user']),
        'rating': !exists(json, 'rating') ? undefined : json['rating'],
        'date': (new Date(json['date'])),
        'asset': json['asset'],
    };
}

export function AssetRatingToJSON(value?: AssetRating | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'rating': value.rating,
        'asset': value.asset,
    };
}


